<div class="about-image" [ngClass]="data.class" loading="lazy">
  <img [src]="data.image.url" alt="image" [ngClass]="data.image.class">
</div>

